export const findСity = (accessibleСities , foundСity: string) =>
  accessibleСities?.find(({ name }) => name === foundСity);
